import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import { createExpense } from "../services";
import type { CreateExpensePayloadApi } from "../types";

export function useCreateExpense(onSuccessCallback?: () => void) {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (payload: CreateExpensePayloadApi) => createExpense(payload),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["expenses"] });

			onSuccessCallback?.();

			toast(
				ToastCustom({
					description: "Sua despesa está salva e já pode ser consultada.",
					title: "Despesa cadastrada com sucesso!",
					variant: "success",
				})
			);

			mutation.reset();
		},
		onError: (error) => {
			if (error instanceof AxiosError) {
				const errorData = error.response?.data;
				if (errorData?.error?.errors?.length > 0 || errorData?.error?.detail) {
					const errorMessages =
						errorData?.error?.errors[0] || errorData?.error?.detail;
					toast(ToastCustom({ description: errorMessages, title: "Erro" }));
					return;
				}
			}

			const message =
				(error as { response?: { data?: { message?: string } } })?.response
					?.data?.message ?? "Erro ao cadastrar despesa";
			toast(
				ToastCustom({
					description: message,
					title: "Erro",
					variant: "error",
				})
			);
		},
	});

	return mutation;
}
